import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

export const SPIKING_GUIDE_ROUTE = "/safety#north-star";

// Blue "DRINK SPIKING SIGNS" map badge — sits beside the Stars 4 Peace Giving Map badge on every public map.
export const SpikingSignsBadge = ({ className = "", testId = "spiking-signs-badge" }) => (
  <Link to={SPIKING_GUIDE_ROUTE} className={`inline-flex items-center gap-2.5 rounded-full pl-1 pr-4 py-1 shadow-xl border-2 bg-[#1D4ED8] border-white/80 hover:bg-[#1e40af] transition-colors ${className}`} data-testid={testId}>
    <span className="relative h-11 w-11 shrink-0 rounded-full bg-white border-2 border-[#1D4ED8] flex items-center justify-center">
      <ShieldAlert className="h-6 w-6 text-[#1D4ED8]" />
    </span>
    <span className="min-w-0 text-left leading-tight">
      <span className="block text-[10px] font-extrabold uppercase tracking-[0.18em] text-white/80">North Star Guide</span>
      <span className="block text-xs sm:text-sm font-extrabold uppercase text-white truncate">Drink Spiking Signs</span>
    </span>
  </Link>
);

// Drop-in overlay for maps that don't already have a bottom-left badge row.
export const MapSpikingOverlay = ({ testId }) => (
  <div className="absolute z-[500] bottom-6 left-3 max-w-[calc(100%-1.5rem)]">
    <SpikingSignsBadge testId={testId} />
  </div>
);

export default SpikingSignsBadge;
